import Vue from "vue";
import VueRouter from "vue-router";
// import Home from "../views/Home.vue";
import Filial from "../views/Filial.vue";
import Mercadoria from "../views/Mercadoria.vue";
import Departamento from "../views/Departamento.vue";
import TabelaPreco from "../views/tabela-preco/TabelaPreco.vue";
import TabelaPrecoList from "../views/tabela-preco/TabelaPrecoList.vue";
import TabelaPrecoItens from "../views/tabela-preco/TabelaPrecoItens.vue";
import TimelineBase from "../views/timeline/TimelineBase.vue";
import TimelineList from "../views/timeline/TimelineList";
import TimelineEdit from "../views/timeline/TimelineEdit";
import Create from "../views/user/Create.vue";
import Activate from "../views/user/Activate.vue";
import Login from "../views/user/Login";
import Player from "../views/Player";
import Integracao from "../views/Integracao";
import PoliticaPrivacidade from "../views/PoliticaPrivacidade";
import ShowMySlide from "@/views/ShowMySlide";

Vue.use(VueRouter);

const routes = [
    {
        path: "/user/create",
        component: Create,
        meta: {
            showInMenu: false,
            layout: "login"
        },
    },

    {
        path: "/user/activate",
        component: Activate,
        meta: {
            isPublic: true,
            showInMenu: false,
            layout: "login"
        },
    },

    {
        path: "/user/login",
        component: Login,
        meta: {
            isPublic: true,
            showInMenu: false,
            layout: "login"
        },
    },

    {
        path: "/show-my-slide/:uid",
        component: ShowMySlide,
        meta: {
            isPublic: true,
            showInMenu: false,
            layout: "fullpage"
        },
    },

    // {
    //     path: "/",
    //     name: "Home",
    //     component: Home,
    //     meta: {
    //         showInMenu: true,
    //         title: "Inicio",
    //         icon: "mdi-home-outline",
    //     },
    // },

    {
        path: "/timeline",
        component: TimelineBase,
        meta: {
            title: "Slides",
            icon: "mdi-view-carousel-outline",
            showInMenu: true,
        },
        children: [
            {
                path: "",
                component: TimelineList,
            },
            {
                path: ":timelineId/edit",
                component: TimelineEdit,
                meta: {
                    title: "Edição",
                },
            }
        ]
    },

    {
        path: "/tabelas-precos",
        component: TabelaPreco,
        meta: {
            title: "Tabelas de Precos",
            icon: "mdi-table-star",
            showInMenu: true,
        },
        children: [
            {
                path: "",
                component: TabelaPrecoList,
            },
            {
                path: ":tabelaPrecoId/itens",
                component: TabelaPrecoItens,
                meta: {
                    title: "Itens",
                },
            },
        ]
    },

    {
        path: "/players",
        component: Player,
        meta: {
            title: "Displays",
            icon: "mdi-television-classic",
            // icon: "mdi-call-split",
            showInMenu: true,
        },
    },

    {
        path: "/mercadorias",
        name: "Mercadorias",
        component: Mercadoria,
        meta: {
            icon: "mdi-cart-outline",
            showInMenu: true,
        },
    },

    {
        path: "/departamentos",
        name: "Departamentos",
        component: Departamento,
        meta: {
            icon: "mdi-group",
            showInMenu: true,
        },
    },

    {
        path: "/filiais",
        name: "Filiais",
        component: Filial,
        meta: {
            icon: "mdi-store-outline",
            showInMenu: true,
        },
    },

    // {
    //     path: "/integracao",
    //     name: "Integração",
    //     component: Integracao,
    //     meta: {
    //         icon: "mdi-connection",
    //         showInMenu: true,
    //     },
    // },

    {
        path: "/politica-de-privacidade",
        component: PoliticaPrivacidade,
        name: "Política de Privacidade",
        meta: {
            isPublic: true,
            showInMenu: false,
            layout: "fullpage"
        },
    },

    // {
    //     path: "/about",
    //     name: "About",
    //     meta: {
    //         showInMenu: true,
    //         title: "Sobre",
    //         icon: "mdi-information-variant",
    //     },
    //     // route level code-splitting
    //     // this generates a separate chunk (about.[hash].js) for this route
    //     // which is lazy-loaded when the route is visited.
    //     component: () =>
    //         import(/* webpackChunkName: "about" */ "../views/About.vue")
    // }
];

const router = new VueRouter({
    mode: "history",
    base: process.env.BASE_URL,
    routes
});



//roda antes de qualquer rota pra prevenir usuario nao atenticado
// router.beforeEach((to, from, next) => {
//     // redirect to login page if not logged in and trying to access a restricted page
//     const publicPages = ['/user/login', '/user/activate', '/show-my-slide'];
//     const authRequired = !publicPages.includes(to.path);
//
//     // const loggedIn = false;
//     const loggedIn = localStorage.getItem('user');
//
//     if (authRequired && !loggedIn) {
//         return next('/user/login');
//     }
//
//     next();
// });

router.beforeEach((to, from, next) => {
    const record = to.matched.find(record => record.meta.isPublic);

    if (to.matched.some(record => record.meta.isPublic)) {
        next();
    } else {
        // this route requires auth, check if logged in
        // if not, redirect to login page.
        const loggedIn = localStorage.getItem('user');
        if (!loggedIn) {
            // next({
            //     path: '/user/login',
            //     query: { redirect: to.fullPath }
            // });
            next('/user/login');
        } else {
            next();
        }
    }
});

export default router;
